<template>
  <div class="resume">
    <h1>Resume</h1>
    <div class="row">
      <div class="col">
        <div class="timeline clearfix">
          <h2>Experience</h2>
          <div
            v-for="(experience, index) in experiences"
            :key="index"
            class="timeline-item clearfix"
          >
            <div class="left-part">
              <h4 class="item-period">{{ experience.period }}</h4>
              <span class="item-company">{{ experience.company }}</span>
            </div>
            <div class="divider"></div>
            <div class="right-part">
              <h3 class="item-title">
                {{ experience.title }}
              </h3>
              <h3 class="item-sub-title">
                <span>{{ experience.period }}</span> {{ experience.company }}
              </h3>
              <div>
                <p>{{ experience.desc }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="timeline clearfix">
          <h2>Education</h2>
          <div
            v-for="(education, index) in educations"
            :key="index"
            class="timeline-item clearfix"
          >
            <div class="left-part">
              <h4 class="item-period">{{ education.period }}</h4>
              <span class="item-company">{{ education.company }}</span>
            </div>
            <div class="divider"></div>
            <div class="right-part">
              <h3 class="item-title">{{ education.title }}</h3>
              <h3 class="item-sub-title">
                <span>{{ education.period }}</span> {{ education.company }}
              </h3>
              <div>
                <p>{{ education.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-5">
        <h2>Programming Skills</h2>

        <div class="skills">
          <div v-for="(skill, index) in skills" :key="index" class="prog">
            <div class="title clearfix">
              <h4>{{ skill.title }}</h4>
              <div class="value">{{ skill.value }}%</div>
            </div>
            <div class="progress">
              <div
                class="progress-percentage"
                :style="`width:${skill.value}%`"
              ></div>
            </div>
          </div>
        </div>

        <h2>Design Skills</h2>

        <div class="skills">
          <div v-for="(skill, index) in designSkills" :key="index" class="prog">
            <div class="title clearfix">
              <h4>{{ skill.title }}</h4>
              <div class="value">{{ skill.value }}%</div>
            </div>
            <div class="progress">
              <div
                class="progress-percentage"
                :style="`width:${skill.value}%`"
              ></div>
            </div>
          </div>
        </div>

        <h2>Languages</h2>

        <div class="langs">
          <div v-for="(item, index) in langs" :key="index" class="prog">
            <div class="title clearfix">
              <h4>{{ item.title }}</h4>
              <div class="value">{{ item.value }}%</div>
            </div>
            <div class="progress">
              <div
                class="progress-percentage"
                :style="`width:${item.value}%`"
              ></div>
            </div>
          </div>
        </div>
        <h2>Certificates</h2>

        <div class="certificates">
          <a
            v-for="(crt, index) in certificates"
            :key="index"
            :href="crt.link"
            class="certificate"
            target="NEW"
          >
            <img :src="crt.img" alt="Certificate image" />
            <div class="certificate-infos">
              <h4 class="title">{{ crt.title }}</h4>
              <div class="certificate-src">{{ crt.src }}</div>
              <div class="certificate-id">ID : {{ crt.id }}</div>
              <div class="certificate-date">12/2020</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      certificates: [
        {
          title: "Laravel 7 Advanced",
          src: "Bright Coding",
          id: "Ae6b55a4",
          img: "https://brightcoding.dev/storage/certifs/B8B7VwK6M6KXKYpYnHmVaVgUTEN6yTRPX3vY2jZN.png",
          link: "https://brightcoding.dev/certificate/ayyoub-belbouk/ae6b55a4",
        },
        {
          title: "PHP",
          src: "Sololearn",
          id: "#1059-11173722",
          img: "https://www.sololearn.com/Certificate/1059-11173722/jpg",
          link: "https://www.sololearn.com/profile/11173722",
        },
        {
          title: "SQL",
          src: "Sololearn",
          id: "#11173722-1060",
          img: "https://www.sololearn.com/certificates/course/en/11173722/1060/landscape/png",
          link: "https://www.sololearn.com/profile/11173722",
        },
      ],
      langs: [
        {
          title: "Ar",
          value: 100,
        },
        {
          title: "Eng",
          value: 60,
        },
        {
          title: "Fr",
          value: 40,
        },
      ],
      skills: [
        {
          title: "PHP",
          value: 90,
        },
        {
          title: "Laravel",
          value: 80,
        },
        {
          title: "JavaScript",
          value: 80,
        },
        {
          title: "JQuery",
          value: 80,
        },
        {
          title: "VueJs",
          value: 70,
        },
        {
          title: "HTML",
          value: 90,
        },
        {
          title: "Css",
          value: 80,
        },
        {
          title: "Bootstrap",
          value: 80,
        },
        {
          title: "Java",
          value: 60,
        },
        {
          title: "C#",
          value: 60,
        },
        {
          title: "Python",
          value: 20,
        },
        {
          title: "SQL",
          value: 70,
        },
        {
          title: "Git",
          value: 70,
        },
      ],
      designSkills: [
        {
          title: "Web Design",
          value: 80,
        },
        {
          title: "Print Design",
          value: 60,
        },
      ],
      experiences: [
        {
          period: "06/2018 - Now",
          company: "Auto-Entrepreneur",
          title: "Full Stack Developer",
          desc: "Creation of website, web application, mobile application, and desktop.Using new technology such as Laravel framework, Vue js, and Flutter.",
        },
        {
          period: "11/2017 - 05/2018",
          company: "Freelancer",
          title: "Full Stack Developer",
          desc: "Creating desktop applications, web applications, and mobile applications.",
        },
        {
          period: "06 - 10/2017",
          company: "Point Logic Sarl",
          title: "Web Developer (Internship)",
          desc: "Update and upgrade desktop applications to web applications,using PHP (OOP ,MVC), HTML, CSS, JS, JQuery, also creating new web and mobiles solutions.",
        },
        {
          period: "02 - 05/2017",
          company: "ForMy",
          title: "Graphic designer",
          desc: "Realization of designs for advertising panels, business cards, and flyers.",
        },
        {
          period: "01/2016",
          company: "Provincial Directorate Safi",
          title: "Internship",
          desc: 'Creation of a web application "Training Management System".',
        },
      ],
      educations: [
        {
          period: "2014-2016",
          company: "ISTA NTIC",
          title: "Specialized technician",
          desc: 'IT Development Techniques on "Specialized Institute of Applied Technology of New Information and Communication Technologies - SAFI". ',
        },

        {
          period: "2013-2015",
          company: "CIVN",
          title: "Formation Qualification",
          desc: "Programming, Network, Maintenance, MS office",
        },

        {
          period: "2012-2013",
          company: "FS Chouab Doukkali",
          title: "Etudiant",
          desc: "SMPC on FS Chouab Doukkali El-Jadida",
        },

        {
          period: "2012",
          company: "Lycee Sidi Bennour",
          title: "Bac",
          desc: "Experimental science: physical science",
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
h2 {
  color: white !important;
}
.resume {
  width: 90%;
  margin: 0 auto;
  & > h1 {
    margin: 0;
  }
}
</style>
